import { VictoryLabel, VictoryLabelProps, VictoryPortal } from 'victory';

interface CustomLabelProps extends VictoryLabelProps {
  ticks: number[];
  index: number;
}

interface CustomSideLabelProps {
  dx: number;
  dy: number;
  isLegacy: boolean;
}

export const CustomSideLabel: React.FC<CustomSideLabelProps> = ({ dx, dy, isLegacy, ...props }) => {
  const sideLabelProps = props as CustomLabelProps;
  const baseYAxis = sideLabelProps.ticks.findIndex((tick) => tick === 0);

  const isEven = (number: number): boolean => number % 2 === 0;

  // Render the label based on the position of the Y axis with a value of 0
  if (
    (isEven(baseYAxis) && isEven(sideLabelProps.index)) ||
    (!isEven(baseYAxis) && !isEven(sideLabelProps.index)) ||
    isLegacy
  )
    return (
      <VictoryPortal>
        <VictoryLabel dx={dx} dy={dy} {...sideLabelProps} />
      </VictoryPortal>
    );
  return null;
};
